import { render, staticRenderFns } from "./entrepreneurshipsOrganizer.vue?vue&type=template&id=04fa9681"
import script from "./entrepreneurshipsOrganizer.vue?vue&type=script&lang=js"
export * from "./entrepreneurshipsOrganizer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports